import React, { FC } from 'react'
import NProgress from 'nprogress'
import Router from 'next/router'
import { useSelector } from 'react-redux'
import FlashMessage from 'components/FlashMessage'
import WindowListener from 'components/Screen'
import useClientSession from 'hooks/clientSession'
import TakeoverIndicator from './TakeoverIndicator'
import HeaderComponent from './Main/Header'
import { getPath } from 'selectors/shared/location'
// https://ricostacruz.com/nprogress/ slim JS loading bar
// We are connecting it to page ( clientside ) transitions in NEXTjs
// to give user some indication of an ACTION taking place
NProgress.configure({
  easing: 'ease',
  speed: 500,
  showSpinner: false,
  trickleSpeed: 300,
})

Router.onRouteChangeStart = (url) => NProgress.start()

Router.onRouteChangeComplete = () => NProgress.done()

Router.onRouteChangeError = () => NProgress.done()

type HeaderProps = {
  isFlashMessageDisabled?: boolean
}

const Header: FC<HeaderProps> = ({ isFlashMessageDisabled }) => {
  useClientSession()
  const path = useSelector(getPath)

  return (
    <nav data-section='main-navigation'>
      <TakeoverIndicator />

      <HeaderComponent />

      {!isFlashMessageDisabled && <FlashMessage />}

      <WindowListener />
    </nav>
  )
}
export default Header
